<template>
  <div>
    <!-- 合同信息 -->
    <!-- <h3 style="padding: 10px;">合同信息</h3> -->
    <section>
      <el-form :model="formInline" :inline="true" label-width="80px">
        <el-form-item label="所属单位">
          <el-autocomplete
            v-model="formInline.company"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入所属单位"
            value-key="unitName"
            clearable
            @clear="clearSearch"
            ref="myAutocomplete"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="人才姓名">
          <el-input
            v-model="formInline.name"
            placeholder="输入人才姓名"
            style="width: 120px"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="formInline.phone"
            placeholder="输入手机号"
            style="width: 120px"
          ></el-input>
        </el-form-item>
        <el-form-item prop="roomNumber" label="房间号">
          <el-input
            v-model="formInline.roomNumber"
            placeholder="输入房间号"
            style="width: 120px"
          ></el-input>
        </el-form-item>
        <el-form-item label="审批状态">
          <el-select style="width: 140px" v-model="formInline.status">
            <el-option label="未审批" value="未审批"></el-option>
            <el-option label="已拒绝" value="已拒绝"></el-option>
            <el-option label="已同意" value="已同意"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入住时间">
          <el-date-picker
            clearable
            size="small"
            v-model="formInline.queryDate"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="时间排序">
					<el-select style="width: 140px;" v-model="formInline.sort" placeholder="请选择合同类型">
						<el-option label="开始时间升序" value="1"></el-option>
						<el-option label="开始时间降序" value="2"></el-option>
						<el-option label="结束时间升序" value="3"></el-option>
						<el-option label="结束时间降序" value="4"></el-option>
						<el-option label="签约时间升序" value="5"></el-option>
						<el-option label="签约时间降序" value="6"></el-option>
					</el-select>
				</el-form-item> -->
        <el-form-item>
          <el-button @click="query" type="primary">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleClear">清空</el-button>
          <el-popover
            placement="bottom"
            width="150"
            v-model="show"
            class="left10 right10"
          >
            <el-checkbox-group v-model="checkList" @change="checkChange">
              <el-checkbox
                :label="val"
                v-for="(val, key) in oldTitleObj"
                :key="key"
                :disabled="val == oneRow"
              ></el-checkbox>
            </el-checkbox-group>
            <el-button slot="reference">筛选列表</el-button>
          </el-popover>
        </el-form-item>

        <div style="float: right; margin-right: 20px">
          <!-- 	<div style="display: inline-block;margin-right: 10px;">
						<el-upload action="/api/bdContract/importContract" name="multipartFile" :show-file-list="false"
							:headers="headers" :on-success="success">
							<el-button type="primary">导入合同</el-button>
						</el-upload>
					</div>
					<el-button type="primary" @click="addTemplate">下载导入模板</el-button> -->
          <el-button v-hasPermi="['apply:checkin:add']" type="primary" @click="addClick"
            >入住申请</el-button
          >
          <!--el-button type="danger" @click="deleteSelected">删除</el-button-->
          <el-button
            v-hasPermi="['apply:checkin:export']"
            @click="exportData"
            type="warning"
            >导出</el-button
          >
        </div>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :key="tableKey"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column
          v-if="key != 'status'"
          v-for="(val, key) in titleObj"
          :prop="key"
          :label="val"
          :key="key"
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-if="key == 'status'"
          style="color: red"
          v-for="(val, key) in titleObj"
          :prop="key"
          :label="val"
          align="center"
          :key="val"
        >
          <template slot-scope="{ row }">
            <img
              style="width: 20px"
              v-if="row.status == '即将过期'"
              src="../../assets/imgs/jg.png"
              alt=""
            />
            <div :style="{ color: row.status == '即将过期' ? 'red' : '' }">
              {{ row.status }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="tel" label="操作" align="center" width="300">
          <template slot-scope="scope">
            <el-button
              v-hasPermi="['apply:checkin:edit']"
              size="mini"
              @click="handleEdit(scope.row)"
              v-if="scope.row.status == '已驳回'"
              >编辑</el-button
            >
            <el-button
              v-hasPermi="['apply:checkin:view']"
              size="mini"
              @click="handleView(scope.row)"
              v-if="scope.row.status != '已驳回'"
              >查看</el-button
            >
            <el-button
              v-hasPermi="['apply:checkin:check']"
              size="mini"
              v-if="scope.row.status == '未审批'"
              @click="handleCheck(scope.row)"
              type="danger"
              >审核</el-button
            >
            <el-button
              v-hasPermi="['apply:checkin:remove']"
              size="mini"
              v-if="scope.row.status == '未审批' || scope.row.status == '已驳回'"
              @click="handleAdjust(scope.row)"
              >删除</el-button
            >
            <el-button
              v-hasPermi="['apply:checkin:edit']"
              size="mini"
              v-if="scope.row.status == '已驳回'"
              @click="submitApplyAgain(scope.row)"
              >再次提交</el-button
            >

            <el-button
              v-hasPermi="['apply:checkin:edit']"
              size="mini"
              v-if="scope.row.register == '已登记'"
              @click="xuzhu(scope.row)"
              >续住</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="formInline.pageSize"
        :current-page="formInline.currentPage"
        layout="total, prev, pager, next,sizes"
        @current-change="handleCurrentChange"
        :total="totalNum"
        @size-change="handleSizeChange"
      />
    </section>

    <!-- 新增、修改模态框 -->
    <addApplication
      :title="title"
      :obj="obj"
      :isCheck="isCheck"
      @doCheckInApply="doCheckInApply"
      @addSubmit="addSubmit"
      @updataSubmit="updataSubmit"
      :dialogVisible="dialogVisible"
    >
    </addApplication>

    <el-dialog
      title="续住"
      :visible.sync="dialogVisible2"
      width="600px"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
    >
      <el-form :model="formData" ref="formData" label-width="100px">
        <div style="display: flex; justify-content: space-between">
          <el-form-item prop="names" label="人才姓名">
            <el-input disabled v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item prop="company" label="所属单位">
            <el-input disabled v-model="formData.company"></el-input>
          </el-form-item>
        </div>
        <div style="display: flex; justify-content: space-between">
          <el-form-item prop="checkInTime" label="入住日期">
            <el-date-picker
              disabled
              type="date"
              placeholder="选择入住日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="formData.checkInTime"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="endTime" label="截止日期">
            <el-date-picker
              type="date"
              placeholder="选择截止日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="formData.endTime"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="confirmClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import addApplication from "./component/addApplication.vue";
import tableParValueChange from "./component/Cje.js";
export default {
  data() {
    return {
      dialogVisible2: false,
      tableKey: 1,
      headers: {
        //请求头
        Authorization: sessionStorage.token,
      },
      oneRow: "", //当checkList列表只有一项时,选择框不可点击
      checkList: [
        "所属单位",
        "人才姓名",
        "入住日期",
        "截止日期",
        "房间号",
        "入住要求",
        "其他成员",
        "手机号",
        "审批状态",
      ],
      show: false, //控制筛选列的多选框
      titleObj: {
        //表头
        company: "所属单位",
        name: "人才姓名",
        checkInTime: "入住日期",
        endTime: "截止日期",
        roomNum: "房间号",
        //requirement: "入住要求",
        //members: "其他成员",
        phone: "手机号",
        examStatus: "看房状态",
        status: "审批状态",
        register: "登记状态",
      },
      options: [],
      oldTitleObj: {}, //备份表头
      multipleSelection: [],
      formInline: {
        company: "",
        name: "",
        phone: "",
        //selectedRoom:'',
        status: "",
        approvalStatus: "",
        currentPage: 1,
        pageSize: 10,
        roomNumber: "",
        contractor: "",
      },
      oldFormInline: "",
      obj: {},
      tableData: [],
      pageSize: 10, //
      currentPage: 1, //当前页号
      totalNum: 0, //总页数
      title: "",
      dialogVisible: false,
      isCheck: false,
      flag: null,
      formData: {},
      adjustVisible: false, //调剂模态框的显隐
      adjustForm: {
        region: null,
      },
    };
  },
  components: {
    addApplication,
  },
  watch: {
    $route(val) {
      console.log(val);
      // this.getPath()
    },
  },
  mounted() {
    console.log(this.$route.query.name);
    if (this.$route.query.name != undefined) {
      this.formInline.company = this.$route.query.name;
    }
    // this.formInline.contractor=this.$route.query.name
    this.oldFormInline = JSON.parse(JSON.stringify(this.formInline));
    this.oldTitleObj = JSON.parse(JSON.stringify(this.titleObj));
    this.getAll();
    this.getRoomTree("");
  },
  methods: {
    xuzhu(row) {
      this.formData = JSON.parse(JSON.stringify(row));
      this.dialogVisible2 = true;
    },
    getRoomTree(company) {
      let newRoomTree = [];
      this.$http.get("/api/roomManage/getRoomTree?company=" + company).then((res) => {
        console.log(res);
        res.data.data.forEach((item1, index1) => {
          newRoomTree.push({
            value: item1.building,
            label: item1.building,
            children: [],
          });
          item1.getStoreyRoomResList.forEach((item2, index2) => {
            newRoomTree[index1].children.push({
              value: item2.storey,
              label: item2.storey,
              children: [],
            });
            item2.getRoomResList.forEach((item3, index3) => {
              newRoomTree[index1].children[index2].children.push({
                value: item3.id,
                label: item3.roomNumber,
              });
            });
          });
        });
        this.options = newRoomTree;
      });
    },
    clearSearch() {
      this.$refs.myAutocomplete.handleFocus();
    },
    querySearchAsync(queryString, cb) {
      console.log(this.formInline.company);
      if (this.formInline.company == undefined) {
        this.formInline.company = "";
      }
      this.$http
        .get("/api/ownerManage/getOwners?company=" + this.formInline.company)
        .then((res) => {
          console.log("查询所有单位信息", res.data.data);
          let result = res.data.data;
          cb(result);
        });
    },
    success(res) {
      if (res.code == 0) {
        this.getAll();
        this.$message.success("导入成功");
      } else {
        this.$message.error("导入失败");
      }
    },
    addTemplate() {
      //下载导入模板
      this.$http
        .post(
          `/api/export/exportContractModel`,
          {},
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json;charset=utf-8",
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "合同导入模板.xls";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },
    checkChange(val) {
      //筛选列复选框被改变
      var newObj = {};
      for (var key in this.oldTitleObj) {
        if (val.indexOf(this.oldTitleObj[key]) != -1) {
          newObj[key] = this.oldTitleObj[key];
        }
      }
      this.titleObj = newObj;
      if (val.length == 1) {
        //只有一列时,复选框禁止勾选
        this.oneRow = val[0];
        this.$message.warning("表格内容至少显示一列");
        return;
      }
      this.oneRow = "";
    },
    doCheckInApply(list) {
      //console.log(list)
      let url = "/api/bdCheckInApply/doCheckInApply";
      console.log("list：", JSON.stringify(list));
      // return
      this.$http
        .post(url, list)
        .then((res) => {
          console.log("res:", JSON.stringify(res));
          if (res.data.code == 200) {
            this.addClose();
            // this.$message.success(res.data.msg);
            this.$message.success("入住已确认");
            this.getAll();
            // this.getAll();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    confirmClick() {
      this.updataSubmit(this.formData);
    },
    updataSubmit(formData) {
      // let data = {
      // 	id: formData.id,
      // 	requirement: formData.requirement,
      // 	members: formData.members,
      // }
      this.$http
        .post("/api/bdCheckInApply/updateCheckInApply", formData)
        .then((res) => {
          if (res.data.code == 0) {
            this.addClose();
            this.getAll();
            this.$message.success(res.data.message);
            if (formData.status == "已驳回") {
              this.addSubmit(formData);
              // this.$http.post("/api/bdCheckInApply/submitCheckInAgain", { id: formData.id }).then(res => {
              // 	this.getAll();
              // })
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //再次提交入住申请
    submitApplyAgain(row) {
      console.log("row:", JSON.stringify(row));

      this.$confirm("确认再次提交入住申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.addSubmit(row);
          // this.$http.post("/api/bdCheckInApply/submitCheckInAgain", row).then(res => {
          // 	console.log('res:', JSON.stringify(res));
          // 	if (res.data.code == 200) {
          // 			this.addClose()
          // 			this.$message.success(res.data.msg)
          // 			this.getAll();
          // 	} else {
          // 			this.$message.error(res.data.msg)
          // 	}
          // }).catch(err => {
          // 		console.log(err)
          // })
        })
        .catch(() => {
          this.$message({
            message: "已取消提交",
          });
        });
    },
    addSubmit(list) {
      const loading = this.$loading({
        lock: true,
        text: "努力加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      //let url = "/api/bdCheckInApply/doCheckInApply"
      let url = "/api/admin/pc/flow/start/takeIn";
      // if (list.checkInTime != null && list.endTime != null) {
      // 	console.log(list.checkInTime)
      // 	list.checkInTime = new Date(list.checkInTime).getTime()
      // 	list.endTime = new Date(list.endTime).getTime()

      // }
      if (list.startTime > list.endTime) {
        this.$message.error("结束时间不能小于开始时间");
        return;
      }
      if (!list.id) {
        list.roomNumber = list.roomNumber[2];
      } else {
        list.opinion = null;
        list.updateName = null;
        list.updateTime = null;
      }
      this.$http
        .post(url, list)
        .then((res1) => {
          if (res1.data.code == 200) {
            // this.$message.success(res1.data.msg);
            if (list.id) {
              this.$http
                .post("/api/bdCheckInApply/removeCheckInApply", {
                  id: list.id,
                })
                .then((res) => {
                  loading.close();
                  if (res.data.code == 0 || res.data.code == 200) {
                    // this.$message.success(res.data.msg);
                    this.$message.success(res1.data.msg);
                    this.addClose();
                    this.getAll();
                  } else {
                    this.$message.error(res.data.msg);
                  }
                });
              //   this.handleAdjust(list);
            } else {
              loading.close();
              this.$message.success(res1.data.msg);
              this.addClose();
              this.getAll();
            }
          } else {
            loading.close();
            this.$message.error(res1.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    query() {
      this.formInline.currentPage = 1;
      this.getAll();
    },
    getAll() {
      this.$http
        .post("/api/bdCheckInApply/queryCheckInApply", {
          ...this.formInline,
        })
        .then((res) => {
          this.tableKey += 1;
          this.tableData = res.data.data.items;
          this.totalNum = res.data.data.totalNum;

          // this.$forceUpdate();
          //console.log('tableData:',JSON.stringify(this.tableData));
          // res.data.data.items.forEach(val => {
          // 	val.checkInTime = val.checkInTime.split("T")[0]
          // 	val.endTime = val.endTime.split("T")[0]

          // })
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //清空
    handleClear() {
      this.formInline = JSON.parse(JSON.stringify(this.oldFormInline));
      this.formInline.company = "";
      this.query();
    },
    //查询
    handleQuery() {},
    //子组件关闭父组件弹窗
    addClose() {
      this.title = "";
      this.dialogVisible = false;
      this.dialogVisible2 = false;
    },
    // 新增
    addClick() {
      this.title = "新增入住";
      this.dialogVisible = true;
      this.flag = true;
    },
    // 删除所选择的
    deleteSelected() {},
    // 导出
    exportData() {
      this.$http
        .post(
          `/api/export/exportCheckIn`,
          {
            ...this.formInline,
            headList: this.checkList,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json;charset=utf-8",
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "入住申请.xls";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },
    // 查看
    handleEdit(row) {
      this.title = "编辑入住";
      this.dialogVisible = true;
      this.flag = true;
      this.obj = {
        ...row,
      };
      this.isCheck = false;
    },
    // 查看入住
    handleView(row) {
      this.title = "查看入住";
      this.dialogVisible = true;
      this.flag = false;
      this.obj = {
        ...row,
      };
      this.isCheck = false;
    },
    // 编辑
    handleEdit2(row) {
      this.title = "编辑入住";
      this.dialogVisible = true;
      this.flag = false;
      this.obj = {
        ...row,
      };
      this.isCheck = false;
    },

    // 审核
    handleCheck(row) {
      this.title = "审核入住";
      this.dialogVisible = true;
      this.flag = false;
      this.obj = {
        ...row,
      };
      this.isCheck = true;
    },

    // 调剂
    handleAdjust(row) {
      // if (this.multipleSelection.length == 0) {
      // 	this.$message.warning("请勾选要删除的列表")
      // 	return
      // }

      //let userId = []
      // this.multipleSelection.forEach(item => {
      // 	userId.push(item.id)
      // })
      //userId.push(row.id);

      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$http
            .post("/api/bdCheckInApply/removeCheckInApply", {
              id: row.id,
            })
            .then((res) => {
              console.log("res:", JSON.stringify(res));
              if (res.data.code == 0 || res.data.code == 200) {
                this.$message.success(res.data.msg);
                this.getAll();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
          });
        });
    },
    // 分页
    // 当前页
    handleCurrentChange(val) {
      console.log(val);
      this.formInline.currentPage = val;
      this.getAll();
    },
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.getAll();
    },
  },
};
</script>

<style scoped="scoped">
section {
  margin-top: 20px;
}
</style>
